export enum ConsentType {
    AADHAAR_FOR_VERIFICATION = 'AADHAAR_FOR_VERIFICATION',
    LENDER_EXPOSURE_FOR_BORROWER = 'LENDER_EXPOSURE_FOR_BORROWER',
    LENDER_LOAN_AGREEMENT_REVIEWED = 'LENDER_LOAN_AGREEMENT_REVIEWED',
    LENDER_EXPOSURE_ACROSS_P2P_PLATFORMS = 'LENDER_EXPOSURE_ACROSS_P2P_PLATFORMS',
    BORROWER_EXPOSURE_ACROSS_P2P_PLATFORMS = 'BORROWER_EXPOSURE_ACROSS_P2P_PLATFORMS',
    TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
    EQUIFAX_CHECK = 'EQUIFAX_CHECK',
    LENDER_SWIFT_AGREEMENT_REVIEWED = 'LENDER_SWIFT_AGREEMENT_REVIEWED',
    CREDIT_HISTORY_CHECK = 'CREDIT_HISTORY_CHECK',
    MARKETING_CONSENT = 'MARKETING_CONSENT'
}

export class ConsentAudit {
    public loanApplicationId: String;
    public givenBy: string;
    public type: ConsentType;

    constructor(type?: ConsentType, loanApplicationId?: string) {
        this.type = type;
        this.loanApplicationId = loanApplicationId;
    }
}
